<ion-app>
  <ion-router-outlet [swipeGesture]="true" [animated]="true"></ion-router-outlet>
  <div ngpToastViewport class="group/toast-container"></div>
</ion-app>
